// @ts-nocheck

/* eslint-disable sonarjs/no-duplicate-string */

import { keyBy, sortBy } from 'lodash';

import { Target } from '../client';
import { __, getLang } from '../i18n/l10n';
import type { BetState } from '../states/entities/bets';
import type { MatchState } from '../states/entities/matches';
import { BetTypes, SpecialBetGroups } from '../types/bet';
import { BetTemplates } from '../types/bet';
import type { BetTemplate } from '../types/bet';
import { LabelConfigurations } from '../types/betGroup';
import type { LabelConfiguration } from '../types/betGroup';
import type { BetGroupOutcome, OutcomeStateWithValue } from '../types/betGroup';
import { CustomBetTemplates } from '../types/betTemplate';
import { Locales } from '../types/common';

export const getLabelConfiguration = (betTemplate: BetTemplate): LabelConfiguration => {
  switch (betTemplate) {
    default:
    case BetTemplates.TWO_WAY:
    case BetTemplates.THREE_WAY:
    case BetTemplates.SET_SCORE:
    case BetTemplates.SCORE:
    case BetTemplates.DYNAMIC:
    case BetTemplates.ASIAN_HANDICAP:
    case BetTemplates.OVER_UNDER:
    case CustomBetTemplates.SOCCER_VERSUS:
    case CustomBetTemplates.BASKETBALL_POINT_PLAYER:
    case CustomBetTemplates.SOCCER_SCORERS_PERIOD:
    case CustomBetTemplates.HANDBALL_SCORERS_PLAYER:
    case CustomBetTemplates.SOCCER_PLAYER_PROPS:
      return LabelConfigurations.INSIDE_BUTTON;
    case BetTemplates.LIST_ODD:
    case BetTemplates.LIST:
    case CustomBetTemplates.SOCCER_CARD_PLAYER:
    case CustomBetTemplates.SOCCER_SCORERS_AND_TEAM_WINS:
    case CustomBetTemplates.SOCCER_SCORERS_OVERTIME:
    case CustomBetTemplates.MULTICHOICE_MM_SOCCER_SCORERS:
    case CustomBetTemplates.MULTICHOICE_MM_ICE_HOCKEY_SCORERS:
    case CustomBetTemplates.MULTICHOICE_MM_FOOTBALL_SCORERS:
    case CustomBetTemplates.MULTICHOICE_MM_RUGBY_SCORERS:
      return LabelConfigurations.OUTSIDE_BUTTON;
    case BetTemplates.ASIAN_TEXT_HANDICAP:
    case CustomBetTemplates.SOCCER_SCORERS:
    case CustomBetTemplates.SOCCER_GOAL_TYPE:
    case CustomBetTemplates.SOCCER_COMPETITOR_GOAL_TYPE:
    case CustomBetTemplates.FOOTBALL_SCORERS:
    case CustomBetTemplates.ICE_HOCKEY_SCORERS:
    case CustomBetTemplates.RUGBY_SCORERS:
    case CustomBetTemplates.SOCCER_DECISIVE_PLAYERS:
      return LabelConfigurations.NO_LABEL;
  }
};

export const getCustomTemplate = (specialBetGroup: string | null) => {
  switch (specialBetGroup) {
    case SpecialBetGroups.SOCCER_SCORERS_LIVE:
    case SpecialBetGroups.SOCCER_SCORERS_LIVE_WITHOUT_LAST_SCORER:
    case SpecialBetGroups.SOCCER_MULTI_SCORERS_LIVE:
    case SpecialBetGroups.SOCCER_MULTI_SCORERS_PREMATCH:
    case SpecialBetGroups.SOCCER_SCORERS_PREMATCH:
    case SpecialBetGroups.SOCCER_MULTI_SCORER_1_HT:
    case SpecialBetGroups.SOCCER_MULTI_SCORER_2_HT:
    case SpecialBetGroups.SOCCER_SCORER_PERIOD_HALF_TIME:
      return CustomBetTemplates.SOCCER_SCORERS;
    case SpecialBetGroups.SOCCER_DECISIVE_PLAYERS:
      return CustomBetTemplates.SOCCER_DECISIVE_PLAYERS;
    case SpecialBetGroups.SOCCER_PLAYER_PROPS_ASSISTS:
    case SpecialBetGroups.SOCCER_PLAYER_PROPS_SHOTS:
    case SpecialBetGroups.SOCCER_PLAYER_PROPS_SHOTS_ON_GOAL:
    case SpecialBetGroups.SOCCER_PLAYER_PROPS_PASSES:
    case SpecialBetGroups.SOCCER_PLAYER_PROPS_TACKLES:
      return CustomBetTemplates.SOCCER_PLAYER_PROPS;
    case SpecialBetGroups.MULTICHOICE_MM_SOCCER_SCORERS:
      return CustomBetTemplates.MULTICHOICE_MM_SOCCER_SCORERS;
    case SpecialBetGroups.SOCCER_SCORER_PERIOD_10MINUTES:
    case SpecialBetGroups.SOCCER_SCORER_PERIOD_15MINUTES:
      return CustomBetTemplates.SOCCER_SCORERS_PERIOD;
    case SpecialBetGroups.SOCCER_SCORERS_AND_TEAM_WINS:
      return CustomBetTemplates.SOCCER_SCORERS_AND_TEAM_WINS;
    case SpecialBetGroups.SOCCER_NEXT_SCORERS_OVERTIME:
    case SpecialBetGroups.SOCCER_OVER_2_SCORERS_OVERTIME:
    case SpecialBetGroups.SOCCER_SCORERS_OVERTIME_1_HT:
    case SpecialBetGroups.SOCCER_SCORERS_OVERTIME_2_HT:
    case SpecialBetGroups.SOCCER_SCORERS_OVERTIME:
      return CustomBetTemplates.SOCCER_SCORERS_OVERTIME;
    case SpecialBetGroups.RUGBY_SCORERS:
    case SpecialBetGroups.RUGBY_LEAGUE_SCORERS:
    case SpecialBetGroups.RUGBY_7S_SCORERS:
    case SpecialBetGroups.RUGBY_SCORERS_LIVE:
    case SpecialBetGroups.RUGBY_LEAGUE_SCORERS_LIVE:
    case SpecialBetGroups.RUGBY_7S_SCORERS_LIVE:
      return CustomBetTemplates.RUGBY_SCORERS;
    case SpecialBetGroups.ICE_HOCKEY_SCORERS:
    case SpecialBetGroups.ICE_HOCKEY_SCORER_PERIOD:
    case SpecialBetGroups.ICE_HOCKEY_SCORER_LIVE:
    case SpecialBetGroups.ICE_HOCKEY_MULTI_SCORER_LIVE:
      return CustomBetTemplates.ICE_HOCKEY_SCORERS;
    case SpecialBetGroups.MULTICHOICE_MM_ICE_HOCKEY_SCORERS:
      return CustomBetTemplates.MULTICHOICE_MM_ICE_HOCKEY_SCORERS;
    case SpecialBetGroups.FOOTBALL_SCORERS:
      return CustomBetTemplates.FOOTBALL_SCORERS;
    case SpecialBetGroups.MULTICHOICE_MM_FOOTBALL_SCORERS:
      return CustomBetTemplates.MULTICHOICE_MM_FOOTBALL_SCORERS;
    case SpecialBetGroups.MULTICHOICE_MM_RUGBY_LEAGUE_SCORERS:
    case SpecialBetGroups.MULTICHOICE_MM_RUGBY_SCORERS:
      return CustomBetTemplates.MULTICHOICE_MM_RUGBY_SCORERS;
    case SpecialBetGroups.BASKETBALL_POINT_PLAYER:
    case SpecialBetGroups.BASKETBALL_DOUBLE_CHANCE_PLAYER:
    case SpecialBetGroups.BASKETBALL_SUM_POINT_2PLAYERS:
    case SpecialBetGroups.BASKETBALL_SUM_POINT_3PLAYERS:
    case SpecialBetGroups.BASKETBALL_PASS_PLAYER:
    case SpecialBetGroups.BASKETBALL_REBOUND_PLAYER:
    case SpecialBetGroups.BASKETBALL_3POINT_PLAYER:
    case SpecialBetGroups.BASKETBALL_TOTAL_PLAYER_POINTS_REBOUND_ASSIST:
    case SpecialBetGroups.BASKETBALL_TOTAL_PLAYER_POINTS_ASSIST:
    case SpecialBetGroups.BASKETBALL_TOTAL_PLAYER_ASSIST_REBOUND:
    case SpecialBetGroups.BASKETBALL_TOTAL_PLAYER_POINTS_REBOUND:
    case SpecialBetGroups.BASKETBALL_PLAYER_INTERCEPT:
    case SpecialBetGroups.BASKETBALL_PLAYER_BLOCK:
    case SpecialBetGroups.BASKETBALL_PLAYER_LOST_BALL:
    case SpecialBetGroups.BASKETBALL_TOTAL_PLAYER_INTERCEPT_BLOCK:
      return CustomBetTemplates.BASKETBALL_POINT_PLAYER;
    case SpecialBetGroups.BASKETBALL_POINT_PLAYER_OVER_UNDER:
    case SpecialBetGroups.BASKETBALL_PASS_PLAYER_OVER_UNDER:
    case SpecialBetGroups.BASKETBALL_REBOUND_PLAYER_OVER_UNDER:
    case SpecialBetGroups.BASKETBALL_3POINTS_PLAYER_OVER_UNDER:
    case SpecialBetGroups.BASKETBALL_POINT_REBOUND_ASSIST_PLAYER_OVER_UNDER:
    case SpecialBetGroups.BASKETBALL_POINT_PASS_PLAYER_OVER_UNDER:
    case SpecialBetGroups.BASKETBALL_PASS_REBOUND_PLAYER_OVER_UNDER:
    case SpecialBetGroups.BASKETBALL_POINT_REBOUND_PLAYER_OVER_UNDER:
    case SpecialBetGroups.BASKETBALL_PLAYER_INTERCEPT_OVER_UNDER:
    case SpecialBetGroups.BASKETBALL_PLAYER_BLOCK_OVER_UNDER:
    case SpecialBetGroups.BASKETBALL_PLAYER_LOST_BALL_OVER_UNDER:
    case SpecialBetGroups.BASKETBALL_TOTAL_PLAYER_INTERCEPT_BLOCK_OVER_UNDER:
      return CustomBetTemplates.BASKETBALL_PLAYER_OVER_UNDER;
    case SpecialBetGroups.BASKETBALL_NUMBER_OF_POINTS_HEAD_TO_HEAD:
    case SpecialBetGroups.BASKETBALL_NUMBER_OF_ASSISTS_HEAD_TO_HEAD:
    case SpecialBetGroups.BASKETBALL_NUMBER_OF_REBOUNDS_HEAD_TO_HEAD:
      return CustomBetTemplates.BASKETBALL_HEAD_TO_HEAD;
    case SpecialBetGroups.SOCCER_SCORER_VS_COMPETITOR:
    case SpecialBetGroups.SOCCER_SCORER_VS_SCORER:
      return CustomBetTemplates.SOCCER_VERSUS;
    case SpecialBetGroups.SOCCER_SCORERS_GOAL_TYPE:
      return CustomBetTemplates.SOCCER_GOAL_TYPE;
    case SpecialBetGroups.SOCCER_COMPETITOR_GOAL_TYPE:
      return CustomBetTemplates.SOCCER_COMPETITOR_GOAL_TYPE;
    case SpecialBetGroups.SOCCER_DUO_SCORERS:
    case SpecialBetGroups.SOCCER_TRIO_SCORERS:
      return CustomBetTemplates.SOCCER_MULTIPLE_SCORERS;
    case SpecialBetGroups.RUGBY_DUO_SCORERS:
    case SpecialBetGroups.RUGBY_TRIO_SCORERS:
      return CustomBetTemplates.RUGBY_MULTIPLE_SCORERS;
    case SpecialBetGroups.HANDBALL_SCORERS_PLAYER:
      return CustomBetTemplates.HANDBALL_SCORERS_PLAYER;
    case SpecialBetGroups.ICE_HOCKEY_DUO_SCORERS:
    case SpecialBetGroups.ICE_HOCKEY_TRIO_SCORERS:
      return CustomBetTemplates.ICE_HOCKEY_MULTIPLE_SCORERS;
    case SpecialBetGroups.SOCCER_NUMBER_CARD_PLAYER:
      return CustomBetTemplates.SOCCER_CARD_PLAYER;
    default:
      return null;
  }
};

export const getCustomTemplateLabels = (specialBetGroup: string, match: MatchState, bet: BetState) => {
  const { betTitle, betType, betTypeHelp: helperText } = bet;

  switch (specialBetGroup) {
    case SpecialBetGroups.SOCCER_ASIAN_HANDICAP: {
      let title = betTitle;
      if (getLang() !== Locales.ES && betType === BetTypes.SOCCER_ASIAN_HANDICAP_GOAL_DIFFERENCE) {
        const betTitlePrefix = __('handicap format');
        title += ` (${betTitlePrefix})`;
      }
      return { title, helperText };
    }
    case SpecialBetGroups.SOCCER_ASIANTEXT_HANDICAP: {
      let title = betTitle.split('|')[0];
      if (getLang() !== Locales.ES && betType === BetTypes.SOCCER_ASIANTEXT_HANDICAP_GOAL_DIFFERENCE) {
        const betTitlePrefix = __('text format');
        title += ` (${betTitlePrefix})`;
      }
      return { title, helperText };
    }
    case SpecialBetGroups.SOCCER_MULTI_SCORERS_LIVE:
      return { title: __('Multiscorers') };
    case SpecialBetGroups.SOCCER_MULTI_SCORERS_PREMATCH:
      return { title: __('Multiscorers') };
    case SpecialBetGroups.SOCCER_SCORERS_PREMATCH:
    case SpecialBetGroups.SOCCER_SCORERS_LIVE:
    case SpecialBetGroups.SOCCER_SCORERS_LIVE_WITHOUT_LAST_SCORER:
    case SpecialBetGroups.MULTICHOICE_MM_SOCCER_SCORERS:
      return { title: __('Scorers') };
    case SpecialBetGroups.SOCCER_DECISIVE_PLAYERS:
      return { title: __('Decisive players'), helperText: __('!desc:SoccerDecisivePlayer') };
    case SpecialBetGroups.SOCCER_SCORERS_GOAL_TYPE:
      return { title: __('Scorer type') };
    case SpecialBetGroups.SOCCER_COMPETITOR_GOAL_TYPE:
      return { title: __('Type of goal scored by a team') };
    case SpecialBetGroups.SOCCER_SCORER_VS_COMPETITOR:
      return { title: __('Player vs. team'), helperText };
    case SpecialBetGroups.SOCCER_SCORER_VS_SCORER:
      return { title: __('Player vs. player'), helperText };
    case SpecialBetGroups.SOCCER_DUO_SCORERS:
    case SpecialBetGroups.ICE_HOCKEY_DUO_SCORERS:
      return { title: __('Goalscorer Duo'), helperText: __('!desc:SoccerScorerDuo') };
    case SpecialBetGroups.RUGBY_DUO_SCORERS:
      return { title: __('Try scorer Duo'), helperText };
    case SpecialBetGroups.SOCCER_TRIO_SCORERS:
    case SpecialBetGroups.ICE_HOCKEY_TRIO_SCORERS:
      return { title: __('Goalscorer Trio'), helperText: __('!desc:SoccerScorerTrio') };
    case SpecialBetGroups.RUGBY_TRIO_SCORERS:
      return { title: __('Try scorer Trio'), helperText };
    case SpecialBetGroups.SOCCER_SCORER_PERIOD_10MINUTES:
      return { title: __('Goalscorers in a 10 min period') };
    case SpecialBetGroups.SOCCER_SCORER_PERIOD_15MINUTES:
      return { title: __('Goalscorers in a 15 min period') };
    case SpecialBetGroups.SOCCER_SCORER_PERIOD_HALF_TIME:
      return { title: __('Half-time goalscorers') };
    case SpecialBetGroups.SOCCER_MULTI_SCORER_1_HT:
      return { title: __('Half time - Multiple goalscorers') };
    case SpecialBetGroups.SOCCER_MULTI_SCORER_2_HT:
      return { title: __('2nd half - Multiple goalscorers') };
    case SpecialBetGroups.RUGBY_SCORERS:
    case SpecialBetGroups.RUGBY_LEAGUE_SCORERS:
    case SpecialBetGroups.RUGBY_7S_SCORERS:
      return { title: __('Try scorers') };
    case SpecialBetGroups.FOOTBALL_SCORERS:
      return { title: __('Touchdowns scorers') };
    case SpecialBetGroups.BASKETBALL_POINT_PLAYER:
    case SpecialBetGroups.BASKETBALL_PASS_PLAYER:
    case SpecialBetGroups.BASKETBALL_REBOUND_PLAYER:
    case SpecialBetGroups.BASKETBALL_3POINT_PLAYER:
    case SpecialBetGroups.BASKETBALL_DOUBLE_CHANCE_PLAYER:
    case SpecialBetGroups.BASKETBALL_SUM_POINT_2PLAYERS:
    case SpecialBetGroups.BASKETBALL_SUM_POINT_3PLAYERS:
    case SpecialBetGroups.BASKETBALL_POINT_PLAYER_OVER_UNDER:
    case SpecialBetGroups.BASKETBALL_PASS_PLAYER_OVER_UNDER:
    case SpecialBetGroups.BASKETBALL_REBOUND_PLAYER_OVER_UNDER:
    case SpecialBetGroups.BASKETBALL_3POINTS_PLAYER_OVER_UNDER:
    case SpecialBetGroups.BASKETBALL_POINT_REBOUND_ASSIST_PLAYER_OVER_UNDER:
    case SpecialBetGroups.BASKETBALL_POINT_PASS_PLAYER_OVER_UNDER:
    case SpecialBetGroups.BASKETBALL_PASS_REBOUND_PLAYER_OVER_UNDER:
    case SpecialBetGroups.BASKETBALL_POINT_REBOUND_PLAYER_OVER_UNDER:
    case SpecialBetGroups.BASKETBALL_PLAYER_INTERCEPT_OVER_UNDER:
    case SpecialBetGroups.BASKETBALL_PLAYER_BLOCK_OVER_UNDER:
    case SpecialBetGroups.BASKETBALL_PLAYER_LOST_BALL_OVER_UNDER:
    case SpecialBetGroups.BASKETBALL_TOTAL_PLAYER_INTERCEPT_BLOCK_OVER_UNDER:
    case SpecialBetGroups.BASKETBALL_TOTAL_PLAYER_POINTS_REBOUND_ASSIST:
    case SpecialBetGroups.BASKETBALL_TOTAL_PLAYER_POINTS_ASSIST:
    case SpecialBetGroups.BASKETBALL_TOTAL_PLAYER_ASSIST_REBOUND:
    case SpecialBetGroups.BASKETBALL_TOTAL_PLAYER_POINTS_REBOUND:
    case SpecialBetGroups.BASKETBALL_PLAYER_INTERCEPT:
    case SpecialBetGroups.BASKETBALL_PLAYER_BLOCK:
    case SpecialBetGroups.BASKETBALL_PLAYER_LOST_BALL:
    case SpecialBetGroups.BASKETBALL_TOTAL_PLAYER_INTERCEPT_BLOCK:
      return { title: betTitle?.split(' - ')[0] || '', helperText };
    case SpecialBetGroups.BASKETBALL_NUMBER_OF_POINTS_HEAD_TO_HEAD:
    case SpecialBetGroups.BASKETBALL_NUMBER_OF_ASSISTS_HEAD_TO_HEAD:
    case SpecialBetGroups.BASKETBALL_NUMBER_OF_REBOUNDS_HEAD_TO_HEAD:
      return { title: betTitle?.split(' : ')[0] || '', helperText };
    case SpecialBetGroups.ICE_HOCKEY_SCORERS:
    case SpecialBetGroups.ICE_HOCKEY_SCORER_LIVE:
      return { title: __('Scorers'), helperText: __('Excluding extra-time and penalty shoot-out.') };
    case SpecialBetGroups.ICE_HOCKEY_MULTI_SCORER_LIVE:
      return { title: __('Multiscorers'), helperText: __('Excluding extra-time and penalty shoot-out.') };
    case SpecialBetGroups.ICE_HOCKEY_SCORER_PERIOD:
      return { title: __('Goalscorer in a period'), helperText };
    case SpecialBetGroups.HANDBALL_SCORERS_PLAYER:
      return { title: __('Number of goals from the player'), helperText };
    default:
      return null;
  }
};

export const getTemplateHeaders = (specialBetGroup: string | null) => {
  switch (specialBetGroup) {
    case SpecialBetGroups.SOCCER_ASIANTEXT_HANDICAP:
      return [__('Yes'), __('No')];
    case SpecialBetGroups.SOCCER_SCORERS_LIVE:
      return [__('Anytime'), __('!scorer:Next'), __('Last')];
    case SpecialBetGroups.SOCCER_DECISIVE_PLAYERS:
      return [__('Decisive'), __('Scorer'), __('Assistman')];
    case SpecialBetGroups.SOCCER_SCORERS_LIVE_WITHOUT_LAST_SCORER:
      return [__('Anytime'), __('!scorer:Next')];
    case SpecialBetGroups.SOCCER_MULTI_SCORERS_LIVE:
    case SpecialBetGroups.ICE_HOCKEY_MULTI_SCORER_LIVE:
      return [__('2 or more'), __('3 or more')];
    case SpecialBetGroups.SOCCER_SCORERS_PREMATCH:
    case SpecialBetGroups.MULTICHOICE_MM_SOCCER_SCORERS:
      return [__('Anytime'), __('First'), __('Last')];
    case SpecialBetGroups.SOCCER_MULTI_SCORERS_PREMATCH:
    case SpecialBetGroups.SOCCER_MULTI_SCORER_1_HT:
    case SpecialBetGroups.SOCCER_MULTI_SCORER_2_HT: {
      const language = getLang();
      if ([Locales.DE, Locales.PT].indexOf(language) !== -1) {
        return [__('2 or more'), __('3 or more')];
      }
      return [__('2 or more'), __('3 or more'), __('4 or more')];
    }
    case SpecialBetGroups.SOCCER_COMPETITOR_GOAL_TYPE:
    case SpecialBetGroups.SOCCER_SCORERS_GOAL_TYPE:
      return [__('Penalty'), __('Direct free kick'), __('Header')];
    case SpecialBetGroups.SOCCER_SCORER_PERIOD_HALF_TIME:
      return [__('!short:FirstHalf'), __('!short:SecondHalf'), __('!short:BothHalf')];
    case SpecialBetGroups.ICE_HOCKEY_SCORERS:
      return [__('Anytime'), __('2 or more'), __('3 or more')];
    case SpecialBetGroups.ICE_HOCKEY_SCORER_LIVE:
      return [__('Anytime'), __('!scorer:Next')];
    case SpecialBetGroups.ICE_HOCKEY_SCORER_PERIOD:
      return [__('1st'), __('2nd'), __('3rd')];
    case SpecialBetGroups.FOOTBALL_SCORERS:
    case SpecialBetGroups.RUGBY_SCORERS:
    case SpecialBetGroups.RUGBY_LEAGUE_SCORERS:
    case SpecialBetGroups.RUGBY_7S_SCORERS:
    case SpecialBetGroups.RUGBY_SCORERS_LIVE:
    case SpecialBetGroups.RUGBY_LEAGUE_SCORERS_LIVE:
    case SpecialBetGroups.RUGBY_7S_SCORERS_LIVE:
      return [__('Simple touchdown scorer'), __('2 or more'), __('3 or more')];
    default:
      return null;
  }
};

export const getNumberOfLinesFromTemplate = (template: BetTemplate) => {
  switch (template) {
    case BetTemplates.SCORE:
    case BetTemplates.SET_SCORE:
    case BetTemplates.ASIAN_HANDICAP:
    case BetTemplates.OVER_UNDER:
    case BetTemplates.DYNAMIC:
    case BetTemplates.TWO_WAY:
    case BetTemplates.THREE_WAY:
    case CustomBetTemplates.ICE_HOCKEY_MULTIPLE_SCORERS:
    case CustomBetTemplates.SOCCER_MULTIPLE_SCORERS:
    case CustomBetTemplates.RUGBY_MULTIPLE_SCORERS:
      return {
        lineThreshold: 4,
        previewLines: 3,
      };
    case BetTemplates.LIST:
    case BetTemplates.LIST_ODD:
    case CustomBetTemplates.RUGBY_SCORERS:
    case CustomBetTemplates.SOCCER_SCORERS:
    case CustomBetTemplates.SOCCER_PLAYER_PROPS:
    case CustomBetTemplates.SOCCER_SCORERS_AND_TEAM_WINS:
    case CustomBetTemplates.SOCCER_SCORERS_OVERTIME:
    case CustomBetTemplates.SOCCER_DECISIVE_PLAYERS:
    case CustomBetTemplates.FOOTBALL_SCORERS:
    case CustomBetTemplates.ICE_HOCKEY_SCORERS:
    case CustomBetTemplates.MULTICHOICE_MM_SOCCER_SCORERS:
    case CustomBetTemplates.MULTICHOICE_MM_ICE_HOCKEY_SCORERS:
    case CustomBetTemplates.MULTICHOICE_MM_FOOTBALL_SCORERS:
    case CustomBetTemplates.MULTICHOICE_MM_RUGBY_SCORERS:
    case CustomBetTemplates.SOCCER_CARD_PLAYER:
      return {
        lineThreshold: 3,
        previewLines: 2,
      };
    case CustomBetTemplates.SOCCER_SCORERS_PERIOD:
      return {
        lineThreshold: 2,
        previewLines: 1,
      };
    case CustomBetTemplates.HANDBALL_SCORERS_PLAYER:
    case CustomBetTemplates.BASKETBALL_PLAYER_OVER_UNDER:
    case CustomBetTemplates.BASKETBALL_POINT_PLAYER:
      return {
        lineThreshold: 2,
        previewLines: 2,
      };
    case CustomBetTemplates.BASKETBALL_HEAD_TO_HEAD:
      return {
        lineThreshold: 6,
        previewLines: 6,
      };
    default:
      return {
        lineThreshold: 9,
        previewLines: Target.__MOBILE__ ? 5 : 9,
      };
  }
};

export const getNbColumns = (template: BetTemplate, nbOutcomes: number): number => {
  switch (template) {
    case BetTemplates.LIST:
    case BetTemplates.LIST_ODD:
      return 1;
    case BetTemplates.TWO_WAY:
    case CustomBetTemplates.BASKETBALL_PLAYER_OVER_UNDER:
    case CustomBetTemplates.BASKETBALL_HEAD_TO_HEAD:
      return 2;
    case BetTemplates.THREE_WAY:
    case CustomBetTemplates.BASKETBALL_POINT_PLAYER:
    case CustomBetTemplates.HANDBALL_SCORERS_PLAYER:
      return 3;
    default: {
      if (nbOutcomes === 2 || nbOutcomes === 4) {
        return 2;
      }
      return 3;
    }
  }
};

type Outcomes = Array<OutcomeStateWithValue>;

export const getOrderedOutcomes = (outcomes: Outcomes, template: BetTemplate): Outcomes => {
  if (template === BetTemplates.LIST_ODD) {
    return sortBy(outcomes, ['value', 'label']);
  }

  const allOutcomeCodes = outcomes.map((x) => x.code);
  const predefinedOrders = betOddOrderByTemplate[template] || [];
  const outcomeByCodeMap = keyBy(outcomes, 'code');

  const predefinedOrder = predefinedOrders.reduce((correspondingOrder, curr) => {
    if (!correspondingOrder) {
      if (allOutcomeCodes.filter((code) => curr.indexOf(code) !== -1).length === allOutcomeCodes.length) {
        return curr;
      }
    }
    return correspondingOrder;
  }, null);

  if (predefinedOrder) {
    return predefinedOrder.reduce((acc, curr) => {
      if (curr && outcomeByCodeMap[curr]) {
        acc.push(outcomeByCodeMap[curr]);
      }
      return acc;
    }, []);
  }
  return outcomes;
};

export const betOddOrderByTemplate: { [string]: Array<Array<string | null>> } = {
  [BetTemplates.TWO_WAY]: [
    ['1', null, '2'],
    ['red', null, 'green'],
  ],
  [BetTemplates.THREE_WAY]: [
    ['1', 'none', '2'],
    ['1', 'x', '2'],
    ['home', 'none', 'away'],
    ['0-8', '9-11', '12+'],
    ['<89.5', '90-100', '>100.5'],
  ],
  [BetTemplates.OVER_UNDER]: [
    ['over', null, 'under'],
    ['o', null, 'u'],
    ['2', null, '1'],
    ['over 30.5', null, 'under 30.5'],
    ['41+', null, '0-40'],
  ],
  [BetTemplates.ASIAN_TEXT_HANDICAP]: [['yes', 'no']],
};

export const formatBetGroupOutcomes = (
  outcomes?: Array<unknown>,
  matchId: number,
  betId: number,
  marketId: number,
  specialBetValue?: string,
  disableDivider: boolean = false,
) =>
  // eslint-disable-next-line prettier/prettier
  outcomes?.map<BetGroupOutcome>((outcome) => ({
    matchId,
    betId,
    id: outcome.outcomeId,
    marketId,
    specialBetValue,
    disableDivider,
  })) ?? [];
